<template>
  <!-- 菜单权限管理 -->
  <div class="page-wrap">
    <div class="page-container">
      <!-- 搜索筛选卡片 毛玻璃+大圆角+弥散阴影 -->
      <div class="search-card">
        <el-form :label-position="right" label-width="140px">
          <el-form-item label="平台编码:">
            <el-select v-model="platformCode" filterable clearable placeholder="请选择平台编码" size="mini"
              style="width:360px">
              <el-option v-for="item in platformList" :key="item.platformCode" :label="item.platformName"
                :value="item.platformCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查询短剧名称:">
            <el-input v-model="name" placeholder="可模糊查询，如果不存在请添加短剧" clearable size="mini"
              style="width:260px"></el-input><el-button type="success" size="mini" @click="booklistFun()">搜索</el-button>
          </el-form-item>
          <el-form-item label="短剧:">
            <el-select v-model="platformDramaId" filterable clearable placeholder="请先查询短剧，再选择" size="mini"
              style="width:360px">
              <el-option v-for="item in tableData" :key="item.platformDramaId" :label="item.name"
                :value="item.platformDramaId"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-image :src="scope.row.coverUrl" style="width: 50px;height: 50px;"
                :preview-src-list="[scope.row.coverUrl]" />
          </el-form-item> -->
          <el-form-item label="免费/付费:">
            <el-radio-group v-model="playletSeriesUrlType" size="mini">
              <el-radio-button :label="'IAA'">免费</el-radio-button>
              <el-radio-button :label="'IAP'">付费</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="番茄类型:">
            <el-select v-model="fqAccountValue" clearable placeholder="请先选择" size="mini" style="width:260px">
              <el-option v-for="item in fqAccountOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <!-- <span style="color:#f53f3f;font-size:12px;margin-left:10px;">注意是否与上方免费/付费相匹配</span> -->
          </el-form-item>
          <el-form-item label="广告起始集数:" v-if="playletSeriesUrlType == 'IAA'">
            <el-select v-model="ggstartEpisode" filterable clearable placeholder="请选择广告起始集数" size="mini"
              style="width:360px" @click="fanqieadPanelFun()" @change="onggstartEpisodeChange">
              <el-option v-for="item in ggData" :key="item.panel_template_id" :label="item.start_episode"
                :value="item.panel_template_id"></el-option>
            </el-select>
            <span style="color:#f53f3f;font-size:12px;margin-left:10px;">当无数据的时候，说明平台方后台已创建，需要手动添加</span>
          </el-form-item>
          <el-form-item label="充值模板选择:" v-if="playletSeriesUrlType == 'IAP'">
            <el-select v-model="czstartEpisode" filterable clearable placeholder="请选择充值模版" size="mini"
              style="width:480px" popper-class="purchase-template-select-popper" @click="fanqiepurchasePanelFun()"
              @change="onPurchasePanelChange">
              <el-option v-for="item in czData" :key="item.panel_template_id" :value="item.panel_template_id"
                :label="item.panel_name">
                <div class="panel-option-item">
                  <div>{{ item.panel_name }} {{ (item.product_list[0].pay_fee / 100).toFixed(2) }}元</div>
                  <div v-for="prod in item.product_list" :key="prod.segment_number">
                    档位{{ prod.segment_number }}=>解锁集数:{{ prod.unlock_episode }},支付折扣:{{ (prod.discount / 100).toFixed(2)
                    }},用户支付金额:{{ (prod.pay_fee / 100).toFixed(2) }}元
                  </div>
                </div>
              </el-option>
            </el-select>
            <span style="color:#f53f3f;font-size:12px;margin-left:10px;">当无数据的时候，说明平台方后台已创建，需要手动添加</span>
          </el-form-item>
          <el-form-item label="推广链名称:">
            <el-input v-model="promotionName" placeholder="填写推广链接名称" disabled="true" clearable size="mini"
              style="width:360px"></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input v-model="remark" placeholder="选填,备注" clearable size="mini" disabled="true"
              style="width:360px"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="success" size="mini" @click="createPromotionFun()">生成推广链接</el-button>
            <el-button size="mini" @click="ResetFun()">重置</el-button>
            <el-button type="warning" size="mini" @click="createReserveFun()">生成预打链</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>




  </div>
</template>

<script>
import { bookplatformList, booklist, fanqiepurchasePanel, fanqieadPanel, fanqiecreatePromotion } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch, computed } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件

export default {
  name: 'ylycreatePromotion',
  components: { pagination },
  props: ['data'],
  // 声明组件抛出的事件（推荐加上）
  emits: ['zdgetCannelFun'],

  setup(props, context) {
    const { emit } = context
    const state = reactive({
      //平台编码
      platformCode: props.data.platformCode,
      //模糊查询名称
      name: props.data.selectPromotionData,
      //选中的短剧id
      platformDramaId: '',
      //短剧数据
      tableData: [],
      //所有启用的平台的数据
      platformList: [],
      //番茄账号
      fqAccount: [
        { label: '端原生付费漫剧', value: '1855633968499864' },
        { label: '端原生免费漫剧', value: '1855633968499848' },
        { label: '端原生付费短剧', value: '1851001214864440' },
        { label: '端原生免费短剧', value: '1851001214864424' }
      ],
      //番茄账户类型
      fqAccountValue: '',
      //免费或付费
      playletSeriesUrlType: 'IAA',
      //选中的广告起始集数:
      ggstartEpisode: '',
      //广告起始集数数据:
      ggData: [],
      //选中的充值模板:
      czstartEpisode: '',
      //充值模板数据:
      czData: [],
      //推广链接名称
      promotionName: '',
      //备注
      remark: '',
      //类型数据
      typeList: [{ label: '端真人剧', value: '端真人剧' }, { label: '端漫剧', value: '端漫剧' }],

      // //短剧重置数据
      // restform: {
      //   platformCode: '',
      //   type: '',
      //   bookIds: [],
      //   remark: ''
      // },
      // //添加短剧的数据
      // form: {
      //   platformCode: '',
      //   type: '',
      //   bookIds: [],
      //   remark: ''
      // },
      // 条数
      pagesize: 100,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,

      //番茄获取免费剧目可用广告解锁集
      fanqieadPanelFun: () => {
        if (state.fqAccountValue.length > 0 && state.platformDramaId.length > 0) {
          const datas = {
            distributorId: state.fqAccountValue,
            bookId: state.platformDramaId,
          }
          fanqieadPanel(datas).then((res) => {
            state.ggData = res.data
          })
        } else {
          ElMessage.error('请先选中短剧和番茄类型')
        }
      },

      //番茄获取付费剧目可用面板参数
      fanqiepurchasePanelFun: () => {
        if (state.fqAccountValue.length > 0 && state.platformDramaId.length > 0) {
          const datas = {
            distributorId: state.fqAccountValue,
            bookId: state.platformDramaId,
          }
          fanqiepurchasePanel(datas).then((res) => {
            state.czData = res.data
          })
        } else {
          ElMessage.error('请先选中短剧和番茄类型')
        }
      },
      //格式化每一个panel下拉显示文本，模仿截图样式
      formatPanelLabel: (item) => {
        // 取第一个档位的pay_fee作为面板标题后面的金额
        const firstPay = (item.product_list[0].pay_fee / 100).toFixed(2)
        let str = `${item.panel_name} ${firstPay}元`

        item.product_list.forEach((prod) => {
          const discountVal = (prod.discount / 100).toFixed(2)
          const feeVal = (prod.pay_fee / 100).toFixed(2)
          str += `\n档位${prod.segment_number}=>解锁集数:${prod.unlock_episode},支付折扣:${discountVal},用户支付金额:${feeVal}元`
        })
        return str
      },
      //番茄付费的时候自动选中文字
      onPurchasePanelChange: (templateId) => {
        // 清空选择的时候，推广名称也清空
        if (!templateId) {
          state.promotionName = ''
          state.remark = ''
          return
        }
        // 根据panel_template_id找到选中的panel
        const targetPanel = state.czData.find(item => item.panel_template_id === templateId)
        if (!targetPanel) return

        // 安全防护，防止product_list为空
        if (!targetPanel.product_list || targetPanel.product_list.length === 0) {
          state.promotionName = targetPanel.panel_name
          return
        }
        //根据选中的platformDramaId找到tableData里面的对象
        const DataItem = state.tableData.find(item => item.platformDramaId === state.platformDramaId)

        const firstFee = (targetPanel.product_list[0].pay_fee / 100).toFixed(2)
        // 拼接第一行文字，赋值给推广链名称
        state.remark = `${state.playletSeriesUrlType}-${DataItem.name}-${targetPanel.panel_name} ${firstFee}元`
        state.promotionName = DataItem.name

      },
      //番茄免费的推广名称自动变化
      onggstartEpisodeChange: (templateId) => {
        if (!templateId) {
          state.promotionName = ''
          state.remark = ''
          return
        }
        // 根据选中的panel_template_id找ggData里面的对象
        const targetAdPanel = state.ggData.find(item => item.panel_template_id === templateId)
        if (!targetAdPanel) return
        //根据选中的platformDramaId找到tableData里面的对象
        const DataItem = state.tableData.find(item => item.platformDramaId === state.platformDramaId)
        //拼接格式 iaa‑卡 + start_episode
        state.remark = `${state.playletSeriesUrlType}-${DataItem.name}-集数 ${targetAdPanel.start_episode}`
        state.promotionName = DataItem.name

      },
      //生成推广链接
      createPromotionFun: () => {
        //番茄创建链接
        if (state.platformCode == '番茄短剧') {
          const datas = {
            distributorId: state.fqAccountValue,
            bookId: state.platformDramaId,
            purchasePanelTemplateId: state.playletSeriesUrlType == 'IAA' ? state.ggstartEpisode : state.czstartEpisode,
            promotionName: state.promotionName,
            remark: state.remark,
            playletSeriesUrlType: state.playletSeriesUrlType,
            type: 1,
          }
          fanqiecreatePromotion(datas).then((res) => {
            console.log(res)
            if (res.data = 200) {
              ElMessage.success('添加推广链接成功')
              emit('zdgetCannelFun')
            }
          })
        }

      },
      // // 生成预打链标识
      createReserveFun: () => {
        const remarkS = '（预打链）-' + state.remark
        //番茄创建链接
        if (state.platformCode == '番茄短剧') {
          const datas = {
            distributorId: state.fqAccountValue,
            bookId: state.platformDramaId,
            purchasePanelTemplateId: state.playletSeriesUrlType == 'IAA' ? state.ggstartEpisode : state.czstartEpisode,
            promotionName: state.promotionName,
            remark: remarkS,
            playletSeriesUrlType: state.playletSeriesUrlType,
            type: 1,
          }
          fanqiecreatePromotion(datas).then((res) => {
            console.log(res)
            if (res.data = 200) {
              ElMessage.success('系统添加推广链接成功')
              emit('zdgetCannelFun')
            }
          })
        }
      },

      //重置短剧
      handleResetPackage: () => {
        // 深拷贝 restform，切断引用
        state.form = JSON.parse(JSON.stringify(state.restform))
      },
      //推广链接的重置
      ResetFun: () => {
        state.platformCode = ''
        state.name = ''
        state.platformDramaId = ''
        state.tableData = []
        state.fqAccountValue = ''
        state.playletSeriesUrlType = 'IAA'
        state.ggstartEpisode = ''
        state.ggData = [],
          state.czstartEpisode = ''
        state.czData = []
        state.promotionName = ''
        state.remark = ''
      },


    })

    //番茄类型下拉根据免费/付费联动过滤
    const fqAccountOptions = computed(() => {
      if (state.playletSeriesUrlType === 'IAA') {
        return state.fqAccount.filter((item) => item.value === '1855633968499848' || item.value === '1851001214864424')
      }
      if (state.playletSeriesUrlType === 'IAP') {
        return state.fqAccount.filter((item) => item.value === '1855633968499864' || item.value === '1851001214864440')
      }
      return state.fqAccount
    })

    //切换免费/付费时，若已选番茄类型不在可选范围内则清空，避免误选不匹配
    watch(() => state.playletSeriesUrlType, () => {
      const validValues = fqAccountOptions.value.map((item) => item.value)
      if (state.fqAccountValue && !validValues.includes(state.fqAccountValue)) {
        state.fqAccountValue = ''
        state.ggstartEpisode = ''
        state.ggData = []
        state.czstartEpisode = ''
        state.czData = []
        state.promotionName = ''
        state.remark = ''
      }
    })



    //短剧分页查询
    const booklistFun = () => {
      const datas = {
        platformCode: state.platformCode,
        platformDramaId: state.platformDramaId,
        name: state.name,
        currenPage: state.currentPage,
        size: state.pagesize,

      }
      booklist(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
        state.platformDramaId = ''
        if (res.data.data.length == 0) {
          ElMessage.warning('短剧不存在，请手动添加')
        }
      })
    }




    //分销平台下拉框（查询所有启用的平台）
    const bookplatformListFun = () => {
      bookplatformList().then((res) => {
        state.platformList = res.data
      })
    }

    bookplatformListFun()
    if (state.name) { booklistFun() }


    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      fqAccountOptions,
      booklistFun,
      bookplatformListFun
    }
  },

}
</script>

<style lang="scss" scoped>
// 全局页面浅色渐变背景
.page-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 搜索卡片：毛玻璃、大圆角、弥散柔和阴影
.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  transition: all 0.32s ease;
}

// 表格卡片
.table-card {
  border-radius: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
}

.pagination-wrap {
  padding: 8px 4px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.left-buttons {
  display: flex;
  gap: 2px;
  flex-shrink: 1;
  overflow-x: auto;
  padding-bottom: 4px;
}

// ========= ElementPlus 组件深度修改 现代UI 大圆角+hover平滑动画 =========
:deep() {

  // 输入框、选择器大圆角
  .el-input__inner,
  .el-select .el-input__inner {
    border-radius: 12px !important;
    border-color: #e2e8f0;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);

    &:hover {
      border‑color: #b8c8e3;
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.08);
    }

    &:focus {
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }
  }

  // 按钮统一大圆角+平滑hover微交互
  .el-button {
    border‑radius: 12px !important;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);
    box‑shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-1px);
      box‑shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    }

    &:active {
      transform: translateY(0px);
    }
  }

  // 表格样式美化，去掉生硬边框，圆角
  .el-table {
    border‑radius: 14px;
    overflow: hidden;
  }

  .el-table th.el-table__cell {
    background‑color: #f4f7fc !important;
  }

  .el-table__row:hover>td {
    background‑color: rgba(64, 158, 255, 0.04) !important;
  }

  // 弹窗 毛玻璃大圆角弥散阴影
  .modern-dialog.el-dialog {
    border‑radius: 20px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.78);
    backdrop‑filter: blur(16px);
    -webkit‑backdrop‑filter: blur(16px);
    box‑shadow: 0 12px 45px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.9);
  }

  .el-dialog__header {
    padding: 22px 26px 12px;
  }

  .el-dialog__body {
    padding: 10px 26px 22px;
  }

  // 分页组件圆角
  .el-pagination {

    .el-pager li,
    .el-pagination__btn {
      border‑radius: 10px;
    }
  }
}

/* 你的按钮颜色样式保留 */
.btn-orange {
  background-color: #ff9500;
  color: white;
  border: none;
}

.btn-green {
  background-color: #00b42a;
  color: white;
  border: none;
}

.btn-blue {
  background-color: #409eff;
  color: white;
  border: none;
}

.btn-dark-blue {
  background-color: #2b5cb8;
  color: white;
  border: none;
}

.btn-purple {
  background-color: #722ed1;
  color: white;
  border: none;
}

.btn-red {
  background-color: #f53f3f;
  color: white;
  border: none;
}

.btn-dark {
  background-color: #1d2129;
  color: white;
  border: none;
}

.btn-light-blue {
  background-color: #69b1ff;
  color: white;
  border: none;
}

.btn-sky {
  background-color: #40c9ff;
  color: white;
  border: none;
}


/* 不要写scoped */
.purchase-template-select-popper .el-select-dropdown__item {
  height: auto !important;
  /* 取消固定高度，自动撑开 */
  white-space: normal !important;
  /* 允许换行 */
  padding: 10px 16px !important;
  line-height: 1.6;
}

.purchase-template-select-popper .panel-option-item>div {
  margin: 2px 0;
}
</style>